import { Icon } from "./icons/icon";
import { cn } from "~/lib/utils";

interface ImageThumbnailProps {
  src: string;
  srcSet?: string;
  sizes?: string;
  alt: string;
  onDelete: () => void;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

/** Image thumbnail with delete button overlay. */
export function ImageThumbnail({
  src,
  srcSet,
  sizes,
  alt,
  onDelete,
  onClick,
  disabled,
  className,
}: ImageThumbnailProps) {
  const isClickable = !!onClick;

  const image = (
    <img src={src} srcSet={srcSet} sizes={sizes} alt={alt} className={cn("rounded-md object-cover", className)} />
  );

  return (
    <div className="relative shrink-0">
      {isClickable ? (
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          aria-label={alt}
          className={cn("block rounded-md transition-colors", {
            "opacity-50 cursor-not-allowed": disabled,
            "cursor-pointer": !disabled,
          })}
        >
          {image}
        </button>
      ) : (
        image
      )}
      <button
        type="button"
        onClick={onDelete}
        disabled={disabled}
        aria-label="Delete image"
        className={cn(
          "absolute -right-1.5 -top-1.5 flex items-center justify-center rounded-full p-0.5",
          "bg-background text-muted-foreground",
          "transition-colors hover:bg-muted",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          { "opacity-50 cursor-not-allowed": disabled },
        )}
      >
        <Icon i="delete-image" className="size-5" />
      </button>
    </div>
  );
}
